import { useLayoutEffect } from 'react';

/*
 * While a sticky bottom bar is shown, the page scroller (.content) keeps its height as scroll padding
 * so a focused row is never hidden under it (WCAG 2.4.11). The bar wraps on phones, so it is measured.
 */
export const useStickyBarPadding = (ref, active) => {
  useLayoutEffect(() => {
    const bar = ref.current;
    const content = document.querySelector('.content');
    if (!active || !bar || !content) return undefined;
    const prev = content.style.scrollPaddingBottom;
    const apply = () => {
      content.style.scrollPaddingBottom = `${bar.offsetHeight + 8}px`;
    };
    apply();
    const ro = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(apply);
    if (ro) ro.observe(bar);
    return () => {
      if (ro) ro.disconnect();
      content.style.scrollPaddingBottom = prev;
    };
  }, [ref, active]);
};
